/**
 * Plaza 顶部 2 个 FeatureCard 的 SVG 装饰图
 * （蓝色波形 = Voice Design，紫色麦克风 = Voice Clone）
 */

export const VoiceDesignArt = () => (
  <svg
    className="absolute inset-0"
    height="100%"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 240 180"
    width="100%"
  >
    <defs>
      <linearGradient id="fcBlue" x1="0" x2="1" y1="0" y2="1">
        <stop offset="0" stopColor="#7dd3fc" />
        <stop offset="1" stopColor="#0ea5e9" />
      </linearGradient>
    </defs>
    {Array.from({ length: 26 }).map((_, i) => {
      const h =
        22 +
        Math.abs(Math.sin(i * 0.7)) * 72 +
        Math.abs(Math.cos(i * 1.3)) * 32
      return (
        <rect
          key={i}
          fill="url(#fcBlue)"
          height={h}
          opacity={0.7 + ((i * 17) % 30) / 100}
          rx="1.5"
          width="3"
          x={50 + i * 7}
          y={90 - h / 2}
        />
      )
    })}
  </svg>
)

export const VoiceCloneArt = () => (
  <svg
    className="absolute inset-0"
    height="100%"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 240 180"
    width="100%"
  >
    <defs>
      <linearGradient id="vmG" x1="0" x2="0" y1="0" y2="1">
        <stop offset="0%" stopColor="#e9d5ff" />
        <stop offset="100%" stopColor="#7c3aed" />
      </linearGradient>
      <linearGradient id="vmG2" x1="0" x2="1" y1="0" y2="0">
        <stop offset="0%" stopColor="#c084fc" stopOpacity="0.15" />
        <stop offset="50%" stopColor="#a855f7" stopOpacity="0.35" />
        <stop offset="100%" stopColor="#c084fc" stopOpacity="0.15" />
      </linearGradient>
    </defs>

    <g transform="rotate(15 118 133)">
      <rect
        fill="url(#vmG2)"
        height="84"
        rx="28"
        stroke="url(#vmG)"
        strokeWidth="2.2"
        width="56"
        x="90"
        y="31"
      />
      <g opacity="0.72" stroke="#c084fc" strokeWidth="1.4">
        <line x1="93" x2="143" y1="45" y2="45" />
        <line x1="90" x2="146" y1="54" y2="54" />
        <line x1="90" x2="146" y1="63" y2="63" />
        <line x1="90" x2="146" y1="72" y2="72" />
        <line x1="90" x2="146" y1="81" y2="81" />
        <line x1="90" x2="146" y1="90" y2="90" />
        <line x1="93" x2="143" y1="99" y2="99" />
      </g>
      <ellipse
        cx="102"
        cy="45"
        fill="white"
        opacity="0.10"
        rx="9"
        ry="5"
        transform="rotate(-10 102 45)"
      />
      <rect
        fill="#a855f7"
        fillOpacity="0.22"
        height="18"
        rx="5"
        stroke="url(#vmG)"
        strokeWidth="2"
        width="32"
        x="102"
        y="115"
      />
      <path
        d="M 102 131 Q 95 137 94 147"
        fill="none"
        stroke="url(#vmG)"
        strokeLinecap="round"
        strokeWidth="2.2"
      />
      <path
        d="M 134 131 Q 141 137 142 147"
        fill="none"
        stroke="url(#vmG)"
        strokeLinecap="round"
        strokeWidth="2.2"
      />
      <line stroke="url(#vmG)" strokeWidth="2.2" x1="94" x2="142" y1="147" y2="147" />
    </g>

    <line
      stroke="url(#vmG)"
      strokeLinecap="round"
      strokeWidth="4"
      x1="118"
      x2="118"
      y1="147"
      y2="200"
    />

    <g fill="none" stroke="#c084fc" strokeLinecap="round">
      <path d="M 178 52 A 28 28 0 0 1 178 104" opacity="0.80" strokeWidth="2.2" />
      <path d="M 178 36 A 44 44 0 0 1 178 120" opacity="0.50" strokeWidth="1.7" />
      <path d="M 178 20 A 60 60 0 0 1 178 136" opacity="0.26" strokeWidth="1.3" />
    </g>
  </svg>
)
